export const isProductionEnvironment = () =>
  process.env.NEXT_PUBLIC_APP_ENV === 'prod';

export const isSandboxEnvironment = () =>
  process.env.NEXT_PUBLIC_EMBEDDED_LENDING_BACKEND?.includes('sandbox');

export const isProductionSandboxEnvironment = () =>
  isProductionEnvironment() && isSandboxEnvironment();
